"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTypes = exports.DialogButtonWidthResizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var styles = tslib_1.__importStar(require("./Dialog.style"));

var helper_1 = require("../../../../styles/helper");

var __1 = require("../../../..");

var Button_1 = tslib_1.__importDefault(require("../../../Buttons/Button"));

var hooks_1 = require("../../../../hooks");

exports.DialogButtonWidthResizes = ['confirm', 'equal'];
exports.DialogTypes = ['primary', 'secondary', 'gray', 'outline'];
var Dialog = react_1.forwardRef(function (_ref, ref) {
  var _ref$modalKey = _ref.modalKey,
      modalKey = _ref$modalKey === void 0 ? '' : _ref$modalKey,
      className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      _ref$buttonWidthResiz = _ref.buttonWidthResizeType,
      buttonWidthResizeType = _ref$buttonWidthResiz === void 0 ? 'confirm' : _ref$buttonWidthResiz,
      titleText = _ref.titleText,
      titleOptionItem = _ref.titleOptionItem,
      confirmButtonContent = _ref.confirmButtonContent,
      _ref$confirmButtonTyp = _ref.confirmButtonType,
      confirmButtonType = _ref$confirmButtonTyp === void 0 ? 'primary' : _ref$confirmButtonTyp,
      onConfirmClick = _ref.onConfirmClick,
      onCloseClick = _ref.onCloseClick,
      optionButtonContent = _ref.optionButtonContent,
      _ref$optionButtonType = _ref.optionButtonType,
      optionButtonType = _ref$optionButtonType === void 0 ? 'gray' : _ref$optionButtonType,
      onOptionClick = _ref.onOptionClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$optionDisabled = _ref.optionDisabled,
      optionDisabled = _ref$optionDisabled === void 0 ? false : _ref$optionDisabled,
      _ref$hasTitleMotion = _ref.hasTitleMotion,
      hasTitleMotion = _ref$hasTitleMotion === void 0 ? false : _ref$hasTitleMotion;
  var contentRef = react_1.useRef(null);
  hooks_1.useResetScroll(contentRef);
  hooks_1.useDialogPreventParentScroll(isOpen);

  function handleConfirmButtonClick() {
    onConfirmClick && onConfirmClick();
  }

  function handleOptionButtonClick() {
    onOptionClick && onOptionClick();
  }

  function handleClose() {
    toggle && toggle(false);
  }

  function handleClosableClick(event) {
    onCloseClick && onCloseClick(event);
    handleClose();
  }

  hooks_1.useModalHistory(modalKey, isOpen, handleClose);
  return react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
    role: "dialog",
    className: className,
    css: [styles.root, isOpen ? styles.show : styles.hide, helper_1.getBottomSafeAreaPadding()]
  }, {
    children: [Boolean(titleText) && jsx_runtime_1.jsx("div", Object.assign({
      css: [styles.titleWrapper, hasTitleMotion && styles.titleMotion],
      className: "mrt-dialog-title"
    }, {
      children: jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.title
      }, {
        children: [jsx_runtime_1.jsx(__1.Icon, {
          name: "ic_close_md_gray_700",
          alt: "close",
          onClick: handleClosableClick
        }, void 0), jsx_runtime_1.jsx("span", Object.assign({
          css: styles.titleTextWrapper
        }, {
          children: jsx_runtime_1.jsx("span", Object.assign({
            css: !titleOptionItem && styles.titleText
          }, {
            children: titleText
          }), void 0)
        }), void 0), titleOptionItem || null]
      }), void 0)
    }), void 0), jsx_runtime_1.jsx("div", Object.assign({
      ref: ref || contentRef,
      className: "mrt-dialog-content",
      css: styles.content(Boolean(confirmButtonContent), Boolean(titleText))
    }, {
      children: children
    }), void 0), confirmButtonContent && jsx_runtime_1.jsx("div", Object.assign({
      css: styles.footerWrapper
    }, {
      children: jsx_runtime_1.jsxs("div", Object.assign({
        css: [styles.footer, helper_1.getBottomSafeAreaPadding(12)]
      }, {
        children: [optionButtonContent && jsx_runtime_1.jsx("span", Object.assign({
          css: [styles.optionButton, buttonWidthResizeType === 'equal' && styles.equalOptionButton]
        }, {
          children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: optionButtonType,
            onClick: handleOptionButtonClick,
            disabled: optionDisabled
          }, {
            children: optionButtonContent
          }), void 0)
        }), void 0), jsx_runtime_1.jsx("span", Object.assign({
          css: styles.confirmButton
        }, {
          children: jsx_runtime_1.jsx(Button_1.default, Object.assign({
            type: confirmButtonType,
            onClick: handleConfirmButtonClick,
            disabled: disabled,
            loading: loading
          }, {
            children: confirmButtonContent
          }), void 0)
        }), void 0)]
      }), void 0)
    }), void 0)]
  }), void 0), document.body);
});
exports.default = Dialog;